import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { CourseEditDialogComponent } from '@app/main/apps/course-edit-dialog/course-edit-dialog.component';
import { UploadTranslationFileConfirmationDialog, TranslationErrorDialog } from '@app/main/apps/course-edit-dialog/translation-dialog-messages.component';
@NgModule({
    declarations: [
        CourseEditDialogComponent,
        UploadTranslationFileConfirmationDialog,
        TranslationErrorDialog
    ],
    imports: [
        SharedModule,
    ],
    exports: [
        CourseEditDialogComponent
    ]
})
export class CourseEditDialogModule { }
